import React__default from "react";
function useRefs() {
  const refs = React__default.useRef([]);
  const setRefs = React__default.useCallback((index) => (el) => {
    if (el)
      refs.current[index] = el;
  }, []);
  const reset = React__default.useCallback(() => {
    refs.current = [];
  }, []);
  return [refs.current, setRefs, reset];
}
export {
  useRefs as u
};
